<ng-container>
  @if (item().visible === true) {
    @if (root) {
      <div class="layout-menuitem-root-text" routerLinkActive="active-route">
        <a
          (click)="itemClick($event)"
          (mouseenter)="onMouseEnter()"
          class="flex align-items-center pt-3 pb-3"
          [ngClass]="item().class"
          [routerLink]="item().routerLink"
          routerLinkActive="active-route"
          [routerLinkActiveOptions]="
            item().routerLinkActiveOptions || {
              paths: 'exact',
              queryParams: 'ignored',
              matrixParams: 'ignored',
              fragment: 'ignored',
            }
          "
          [fragment]="item().fragment"
          [queryParamsHandling]="item().queryParamsHandling"
          [preserveFragment]="item().preserveFragment"
          [skipLocationChange]="item().skipLocationChange"
          [replaceUrl]="item().replaceUrl"
          [state]="item().state"
          [queryParams]="item().queryParams"
          [attr.target]="item().target"
          tabindex="0"
          pRipple
          [pTooltip]="item().label"
          [tooltipDisabled]="!(isSlim() && root)"
        >
          <i
            [ngClass]="item().icon"
            class="layout-menuitem-icon text-xl font-light ml-2"
          ></i>
          <span class="layout-menuitem-text ml-2">{{ item().label }}</span>
          @if (item().items) {
            <i class="icon-chevron-down layout-submenu-toggler ml-2"></i>
          }
        </a>
      </div>
    }
    @if (item().items || !item().routerLink) {
      <a
        [attr.href]="item().url"
        (click)="itemClick($event)"
        (mouseenter)="onMouseEnter()"
        [ngClass]="item().class"
        [class.active-route]="item().isActive"
        [attr.target]="item().target"
        tabindex="0"
        pRipple
        [pTooltip]="item().label"
        [tooltipDisabled]="!(isSlim() && root && !active())"
      >
        <i
          [ngClass]="item().icon"
          class="layout-menuitem-icon text-4xl font-light"
        ></i>
        <span class="layout-menuitem-text">{{ item().label }}</span>
        @if (item().items) {
          <i class="icon-chevron-down layout-submenu-toggler"></i>
        }
      </a>
    }
    @if (!item().items && item().routerLink) {
      <a
        (click)="itemClick($event)"
        (mouseenter)="onMouseEnter()"
        [ngClass]="item().class"
        [routerLink]="item().routerLink"
        routerLinkActive="active-route"
        [routerLinkActiveOptions]="
          item().routerLinkActiveOptions || {
            paths: 'exact',
            queryParams: 'ignored',
            matrixParams: 'ignored',
            fragment: 'ignored',
          }
        "
        [fragment]="item().fragment"
        [queryParamsHandling]="item().queryParamsHandling"
        [preserveFragment]="item().preserveFragment"
        [skipLocationChange]="item().skipLocationChange"
        [replaceUrl]="item().replaceUrl"
        [state]="item().state"
        [queryParams]="item().queryParams"
        [attr.target]="item().target"
        tabindex="0"
        pRipple
        [pTooltip]="item().label"
        [tooltipDisabled]="!(isSlim() && root)"
      >
        <i
          [ngClass]="item().icon"
          class="layout-menuitem-icon text-4xl font-light"
        ></i>
        <span class="layout-menuitem-text">{{ item().label }}</span>
        @if (item().items) {
          <i class="icon-chevron-down layout-submenu-toggler"></i>
        }
      </a>
    }
    @if (item().items) {
      <ul
        #submenu
        (mouseleave)="active.set(false)"
        [@children]="submenuAnimation()"
        (@children.done)="onSubmenuAnimated($event)"
        class="shadow-1"
      >
        @for (item of item().items; track item.id; let i = $index) {
          <li
            app-menuitem
            [item]="item"
            [index]="i"
            [parentKey]="key()"
            [class]="item.badgeClass"
          ></li>
        }
      </ul>
    }
  }
</ng-container>
